export default "__VITE_ASSET__XWsEHwen__"